import { memo } from "react";

import { Chart } from "primereact/chart";

import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";

export const GraficoEntradasSaidas = memo(function GraficoEntradasSaidas({ chartId, chartType = "bar", chartData, fontSize = 18, goal = null, printing }) {
    const dataComEstilo = {
        ...chartData,
        datasets: (chartData?.datasets || []).map(ds => ({
            ...ds,
            maxBarThickness: 28,
            barPercentage: 0.8,
            categoryPercentage: 0.7,
        })),
    };

    const options = {
        maintainAspectRatio: false,
        animation: printing ? false : undefined,
        plugins: {
            title: {
                display: true,
                text: "Entradas x Saídas de Estoque",
                font: {
                    size: 18
                }
            },
            annotation: {
                annotations: goal !== null && goal !== undefined && goal !== ""
                    ? {
                        line1: {
                            type: "line",
                            yMin: goal,
                            yMax: goal,
                            borderColor: "#c0392b",
                            borderWidth: 2,
                        },
                    }
                    : {},
            },
            datalabels: {
                anchor: "end",
                align: "end",
                rotation: "-90",
                formatter: (value) => {
                    return Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(value);
                },
                font: {
                    size: fontSize
                },
                color: "#000"
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                grace: "18%",
            },
        },
    };

    return (
        <Chart
            id={chartId}
            height={printing ? "140mm" : "850px"}
            width={printing ? "273mm" : "auto"}
            type={chartType}
            data={dataComEstilo}
            plugins={[ChartDataLabels, annotationPlugin]}
            options={options}
        />
    );
});